import "babel-polyfill";
import React from "react";
import { render } from "react-dom";
import "semantic-ui-css/semantic.min.css";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import {
  FIND_CLUB_ROUTE,
  MY_ACCOUNT_ROUTE,
  HOME_ROUTE,
  LOGIN_ROUTE,
  REGISTER_ROUTE,
  CONTACT_ROUTE,
  PRIVACY_POLICY_ROUTE,
  TERMS_CONDITIONS_ROUTE,
  USER_ROUTE,
  CLUBS_ROUTE,
  ABOUT_ROUTE,
  SITEMAP_ROUTE,
  BLOG_ROUTE,
  ATTACT_MORE_PLAYERS_ROUTE
} from "./constants/route.constants";

import Home from "./routes/Home";
import Club from "./routes/Club";
import Clubs from "./routes/Clubs";
import States from "./routes/States";
import FindClub from "./routes/FindClub";
import ContactPage from "./routes/ContactPage";
import LoginPage from "./routes/LoginPage/LoginPage";
import RegisterPage from "./routes/RegisterPage/RegisterPage";
import AccountsPage from "./routes/AccountsPage";
import PrivacyPage from "./routes/PrivacyPage";
import TermsPage from "./routes/TermsPage";
import UserPage from "./routes/UserPage";
import AboutPage from "./routes/AboutPage";
import ErrorPage from "./routes/ErrorPage";
import AttractMorePlayersPage from "./routes/AttractMorePlayersPage";
import store from "./store";

const rootElement = document.getElementById("root");
render(
  <Provider store={store}>
    <BrowserRouter>
      <Switch>
        <Route
          path={`${CLUBS_ROUTE}/:country/:state/:club`}
          render={props => <Club {...props} />}
        />
        <Route
          path={`${CLUBS_ROUTE}/:country/:state`}
          render={props => <Clubs {...props} />}
        />>
        <Route
          path={`${CLUBS_ROUTE}/:country`}
          render={props => <States {...props} />}
        />
        <Route
          path={`${USER_ROUTE}/:name/:id`}
          render={props => <UserPage {...props} />}
        />
        <Route
          path={`${BLOG_ROUTE}${ATTACT_MORE_PLAYERS_ROUTE}`}
          render={props => <AttractMorePlayersPage {...props} />}
        />
        <Route path={LOGIN_ROUTE} render={props => <LoginPage {...props} />} />
        <Route
          path={REGISTER_ROUTE}
          render={props => <RegisterPage {...props} />}
        />
        <Route path={ABOUT_ROUTE} render={props => <AboutPage {...props} />} />
        <Route
          path={FIND_CLUB_ROUTE}
          render={props => <FindClub {...props} />}
        />
        <Route
          path={MY_ACCOUNT_ROUTE}
          render={props => <AccountsPage {...props} />}
        />
        <Route
          path={CONTACT_ROUTE}
          render={props => <ContactPage {...props} />}
        />
        <Route
          path={PRIVACY_POLICY_ROUTE}
          render={props => <PrivacyPage {...props} />}
        />
        <Route
          path={TERMS_CONDITIONS_ROUTE}
          render={props => <TermsPage {...props} />}
        />
        <Route exact path={HOME_ROUTE} render={props => <Home {...props} />} />
        <Route path={SITEMAP_ROUTE} />
        <Route path="*" render={props => <ErrorPage {...props} />} />
      </Switch>
    </BrowserRouter>
  </Provider>,
  rootElement
);
// if (rootElement.hasChildNodes()) {
//   hydrate(
//     <Provider store={store}>
//       <BrowserRouter>
//         <Switch>
//           <Route
//             path={`${CLUBS_ROUTE}/:country/:state/:club`}
//             render={props => <Club {...props} />}
//           />
//           <Route
//             path={`${CLUBS_ROUTE}/:country/:state`}
//             render={props => <Clubs {...props} />}
//           />>
//           <Route
//             path={`${CLUBS_ROUTE}/:country`}
//             render={props => <States {...props} />}
//           />
//           <Route
//             path={`${USER_ROUTE}/:name/:id`}
//             render={props => <UserPage {...props} />}
//           />
//           <Route
//             path={`${BLOG_ROUTE}${ATTACT_MORE_PLAYERS_ROUTE}`}
//             render={props => <AttractMorePlayersPage {...props} />}
//           />
//           <Route
//             path={LOGIN_ROUTE}
//             render={props => <LoginPage {...props} />}
//           />
//           <Route
//             path={REGISTER_ROUTE}
//             render={props => <RegisterPage {...props} />}
//           />
//           <Route
//             path={ABOUT_ROUTE}
//             render={props => <AboutPage {...props} />}
//           />
//           <Route
//             path={FIND_CLUB_ROUTE}
//             render={props => <FindClub {...props} />}
//           />
//           <Route
//             path={MY_ACCOUNT_ROUTE}
//             render={props => <AccountsPage {...props} />}
//           />
//           <Route
//             path={CONTACT_ROUTE}
//             render={props => <ContactPage {...props} />}
//           />
//           <Route
//             path={PRIVACY_POLICY_ROUTE}
//             render={props => <PrivacyPage {...props} />}
//           />
//           <Route
//             path={TERMS_CONDITIONS_ROUTE}
//             render={props => <TermsPage {...props} />}
//           />
//           <Route
//             exact
//             path={HOME_ROUTE}
//             render={props => <Home {...props} />}
//           />
//           <Route path={SITEMAP_ROUTE} />
//           <Route path="*" render={props => <ErrorPage {...props} />} />
//         </Switch>
//       </BrowserRouter>
//     </Provider>,
//     rootElement
//   );
// } else {
//   render(
//     <Provider store={store}>
//       <BrowserRouter>
//         <Switch>
//           <Route
//             path={`${CLUBS_ROUTE}/:country/:state/:club`}
//             render={props => <Club {...props} />}
//           />
//           <Route
//             path={`${CLUBS_ROUTE}/:country/:state`}
//             render={props => <Clubs {...props} />}
//           />>
//           <Route
//             path={`${CLUBS_ROUTE}/:country`}
//             render={props => <States {...props} />}
//           />
//           <Route
//             path={`${USER_ROUTE}/:name/:id`}
//             render={props => <UserPage {...props} />}
//           />
//           <Route
//             path={`${BLOG_ROUTE}${ATTACT_MORE_PLAYERS_ROUTE}`}
//             render={props => <AttractMorePlayersPage {...props} />}
//           />
//           <Route
//             path={LOGIN_ROUTE}
//             render={props => <LoginPage {...props} />}
//           />
//           <Route
//             path={REGISTER_ROUTE}
//             render={props => <RegisterPage {...props} />}
//           />
//           <Route
//             path={ABOUT_ROUTE}
//             render={props => <AboutPage {...props} />}
//           />
//           <Route
//             path={FIND_CLUB_ROUTE}
//             render={props => <FindClub {...props} />}
//           />
//           <Route
//             path={MY_ACCOUNT_ROUTE}
//             render={props => <AccountsPage {...props} />}
//           />
//           <Route
//             path={CONTACT_ROUTE}
//             render={props => <ContactPage {...props} />}
//           />
//           <Route
//             path={PRIVACY_POLICY_ROUTE}
//             render={props => <PrivacyPage {...props} />}
//           />
//           <Route
//             path={TERMS_CONDITIONS_ROUTE}
//             render={props => <TermsPage {...props} />}
//           />
//           <Route
//             exact
//             path={HOME_ROUTE}
//             render={props => <Home {...props} />}
//           />
//           <Route path={SITEMAP_ROUTE} />
//           <Route path="*" render={props => <ErrorPage {...props} />} />
//         </Switch>
//       </BrowserRouter>
//     </Provider>,
//     rootElement
//   );
// }

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js